import * as React from 'react'
import cx from 'classnames'
import styles from './latestNews-style.css'
import CtaButton from '@/components/CtaButton/CtaButton'
import { LinkViewModel } from '@/view-models/LinkViewModel'
import Slider, { Settings } from 'react-slick'
import { FeaturedItemsCardViewModel } from '@/view-models/FeaturedItemsCardViewModel'
import Heading from '@/components/Heading/Heading'
import { ContentCard } from '@/components/ContentCard/ContentCard'

type Props = {
  items: Array<FeaturedItemsCardViewModel>
  link?: LinkViewModel
  heading?: string
  /**
   * New - The section background color
   */
  background?: 'green' | 'default'

  /**
   * @deprecated - Not used in this component
   */
  icon?: string
}

function LatestNews({ link, items, heading, background = 'default' }: Props) {
  const [activeSlide, setActiveSlide] = React.useState<number>(0)
  const visibleItems = items.slice(0, 3)

  const sliderSettings: Settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    accessibility: true,
    centerMode: true,
    centerPadding: '20',
    beforeChange: (_, nextSlide: number) => {
      setActiveSlide(nextSlide)
    },
  }

  return (
    <div
      className={cx(styles.latestNews, 'latestNews', {
        [styles.green]: background === 'green',
      })}
    >
      {(heading || link) && (
        <div className={styles.latestNewsHeader}>
          {heading && (
            <Heading level={2} tag={'h2'} className={styles.latestNewsTitle}>
              {heading}
            </Heading>
          )}

          {link && (
            <CtaButton
              className={styles.latestNewsViewAll}
              link={link}
              version={0}
              noUnderline
            />
          )}
        </div>
      )}

      <div className={styles.latestNewsGrid}>
        {items.map((item) => (
          <ContentCard key={item.title} {...item} />
        ))}
      </div>

      <div className={styles.latestNewsCarousel}>
        <Slider {...sliderSettings}>
          {visibleItems.map((item) => (
            <ContentCard key={item.title} {...item} />
          ))}
        </Slider>

        <div className={styles.carouselIndicators}>
          {visibleItems.map((_, index) => (
            <span
              key={index}
              className={cx(
                styles.carouselIndicator,
                activeSlide === index ? styles.carouselIndicatorActive : '',
              )}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

LatestNews.displayName = 'LatestNews'
export { LatestNews }
export default LatestNews
